var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3674_11732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.472188 6.95653C0.165859 7.91622 -3.90556e-05 8.9386 6.89667e-09 9.99989C-3.90556e-05 11.0612 0.165898 12.0837 0.472227 13.0434L10 13.4782L19.5278 13.0434C19.8341 12.0837 20 11.0612 20 9.99997C20 8.93864 19.8341 7.91622 19.5278 6.95649L10 6.52173L0.472188 6.95653Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5278 6.95656L10.0001 6.52179L0.472246 6.95656C0.381465 7.24109 0.303301 7.5312 0.237793 7.82613H19.7622C19.6967 7.53116 19.6186 7.24101 19.5278 6.95656Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.237793 12.1739C0.303223 12.4688 0.381387 12.7589 0.472168 13.0434L0.473105 13.0435L9.9999 13.4782L19.5277 13.0435C19.6185 12.7589 19.6966 12.4688 19.7621 12.1739H0.237793Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 20C14.4615 20 18.24 17.078 19.5277 13.0435H0.472168C1.75986 17.0779 5.53846 20 9.9999 20Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 6.10355e-05C5.53846 0.000100098 1.75994 2.92209 0.472168 6.95658L19.5277 6.95662C18.2401 2.92205 14.4615 2.1973e-05 9.99994 6.10355e-05Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56972 4.13056C4.56972 3.19396 5.22796 2.41153 6.10698 2.21958C5.9719 2.19005 5.83171 2.17407 5.68772 2.17407C4.60718 2.17407 3.7312 3.05001 3.7312 4.1306C3.7312 5.21118 4.6071 6.08712 5.68772 6.08712C5.83171 6.08712 5.97187 6.0711 6.10698 6.04161C5.228 5.84958 4.56972 5.06716 4.56972 4.13056Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26349 5.01978L7.39591 5.42739H7.8245L7.47778 5.67935L7.61021 6.08696L7.26349 5.83505L6.91669 6.08696L7.04915 5.67935L6.70239 5.42739H7.13099L7.26349 5.01978Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63133 5.01978L8.76379 5.42739H9.19238L8.84562 5.67935L8.97809 6.08696L8.63133 5.83505L8.28457 6.08696L8.41703 5.67935L8.07031 5.42739H8.49887L8.63133 5.01978Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99933 5.01978L10.1317 5.42739H10.5604L10.2136 5.67935L10.346 6.08696L9.99933 5.83505L9.65253 6.08696L9.78503 5.67935L9.43823 5.42739H9.86686L9.99933 5.01978Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3675 5.01978L11.5 5.42739H11.9285L11.5818 5.67935L11.7142 6.08696L11.3675 5.83505L11.0207 6.08696L11.1532 5.67935L10.8064 5.42739H11.235L11.3675 5.01978Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7353 5.01978L12.8678 5.42739H13.2964L12.9497 5.67935L13.0821 6.08696L12.7353 5.83505L12.3886 6.08696L12.521 5.67935L12.1743 5.42739H12.6029L12.7353 5.01978Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63133 3.59686L8.76379 4.00444H9.19238L8.84562 4.25643L8.97809 4.66401L8.63133 4.4121L8.28457 4.66401L8.41703 4.25643L8.07031 4.00444H8.49887L8.63133 3.59686Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99933 3.59686L10.1317 4.00444H10.5604L10.2136 4.25643L10.346 4.66401L9.99933 4.4121L9.65253 4.66401L9.78503 4.25643L9.43823 4.00444H9.86686L9.99933 3.59686Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3675 3.59686L11.5 4.00444H11.9285L11.5818 4.25643L11.7142 4.66401L11.3675 4.4121L11.0207 4.66401L11.1532 4.25643L10.8064 4.00444H11.235L11.3675 3.59686Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7353 3.59686L12.8678 4.00444H13.2964L12.9497 4.25643L13.0821 4.66401L12.7353 4.4121L12.3886 4.66401L12.521 4.25643L12.1743 4.00444H12.6029L12.7353 3.59686Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99933 2.17389L10.1317 2.58155H10.5604L10.2136 2.83346L10.346 3.24112L9.99933 2.9892L9.65253 3.24112L9.78503 2.83346L9.43823 2.58155H9.86686L9.99933 2.17389Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3675 2.17389L11.5 2.58155H11.9285L11.5818 2.83346L11.7142 3.24112L11.3675 2.9892L11.0207 3.24112L11.1532 2.83346L10.8064 2.58155H11.235L11.3675 2.17389Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7353 2.17389L12.8678 2.58155H13.2964L12.9497 2.83346L13.0821 3.24112L12.7353 2.9892L12.3886 3.24112L12.521 2.83346L12.1743 2.58155H12.6029L12.7353 2.17389Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3674_11732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/uz.eabc8cfd0953040128901096e32fe476.svg";
export { ForwardRef as ReactComponent };